import { useState } from "react";
import { Calculator } from "lucide-react";
import { formatCurrency } from "@/lib/api";
import { Input } from "@/components/ui/input";

const num = (v) => { const n = parseFloat(String(v ?? "").replace(",", ".")); return Number.isFinite(n) ? n : null; };
const clamp = (p) => Math.min(100, Math.max(0, p));

// Anteprima ripartizione agenzia/broker su importi di esempio (etichette come nel modulo Broker).
export const BrokerSplitPreview = ({ feePct, provPct, mgmtFee }) => {
  const [prov, setProv] = useState("100");
  const [fee, setFee] = useState("50");
  const pFee = num(feePct);
  const pProv = num(provPct) ?? pFee;
  const mgmt = num(mgmtFee) || 0;
  if (pFee === null && pProv === null) {
    return <p className="col-span-2 text-[11px] text-slate-400 italic" data-testid="broker-split-preview-empty">Inserisci le percentuali per vedere l&apos;anteprima della ripartizione.</p>;
  }
  const P = num(prov) || 0;
  const F = num(fee) || 0;
  const agP = (P * clamp(pProv ?? 0)) / 100;
  const agF = (F * clamp(pFee ?? 0)) / 100;
  const rows = [
    ["Provvigione", P, agP, P - agP, `${clamp(pProv ?? 0)}%`],
    ["FEE", F, agF, F - agF, `${clamp(pFee ?? 0)}%`],
    ["Spese di gestione", mgmt, 0, mgmt, "0%"],
  ];
  return (
    <div className="col-span-2 rounded-lg border border-indigo-200 bg-indigo-50/50 p-3" data-testid="broker-split-preview">
      <div className="flex flex-wrap items-center gap-2 text-xs font-semibold text-indigo-900 mb-2">
        <Calculator className="h-4 w-4" /> Anteprima su un esempio
        <span className="font-normal text-slate-600 ml-auto flex items-center gap-1">Provvigione €
          <Input value={prov} onChange={(e) => setProv(e.target.value)} className="h-7 w-20 text-xs bg-white" data-testid="broker-split-example-prov" />
          FEE €
          <Input value={fee} onChange={(e) => setFee(e.target.value)} className="h-7 w-20 text-xs bg-white" data-testid="broker-split-example-fee" />
        </span>
      </div>
      <table className="w-full text-xs tabular-nums">
        <thead className="text-slate-500"><tr><th className="text-left font-medium">Voce</th><th className="text-right font-medium">Importo</th><th className="text-right font-medium">Mia agenzia</th><th className="text-right font-medium">Broker</th></tr></thead>
        <tbody>
          {rows.map(([l, tot, ag, br, pct]) => (
            <tr key={l} className="border-t border-indigo-100">
              <td className="py-1">{l} <span className="text-slate-400">({pct} a me)</span></td>
              <td className="text-right">{formatCurrency(tot)}</td>
              <td className="text-right text-emerald-700">{formatCurrency(ag)}</td>
              <td className="text-right text-blue-700">{formatCurrency(br)}</td>
            </tr>
          ))}
          <tr className="border-t-2 border-indigo-200 font-bold">
            <td className="py-1">Totale</td>
            <td className="text-right">{formatCurrency(P + F + mgmt)}</td>
            <td className="text-right text-emerald-700" data-testid="broker-split-total-agency">{formatCurrency(agP + agF)}</td>
            <td className="text-right text-blue-700" data-testid="broker-split-total-broker">{formatCurrency(P - agP + F - agF + mgmt)}</td>
          </tr>
        </tbody>
      </table>
      {num(provPct) === null && <p className="text-[10px] text-slate-500 mt-1">Provvigione vuota → usa la stessa % della FEE.</p>}
    </div>
  );
};
